import React, { useEffect, useState } from 'react';
import { Link, Spinner, SpinnerSize } from '@fluentui/react';
import Api from '../../../services/Api';
import InfoTooltip from '../../formFields/InfoTooltip';

const CustomApplicationsList = ({apps}) => {

    const [appUsers, setAppUsers] = useState({});
    const [isLoading, setIsLoading] = useState(false);

    const userFieldsLabels = {
        Bussiness_x0020_Contact_x0020__x: 'Business Contact (owner)',
        Support_x0020_Contact: 'Support Contact',
        Technical_x0020_Contact: 'Technical Contact'
    }

    useEffect(() => {
        const fetchData = async () => {
            await getCustomAppsUsers();
        }
        fetchData();
    }, [])
    

    const getCustomAppsUsers = async () => {
        setIsLoading(true);
        let tempAppUsers = {};
        for (const app of apps) {
            const fields = Object.keys(userFieldsLabels).join(',');
            const res = await Api.get(`SitesPanel/GetCustomAppUsers?iCarUrl=${app.iCarUrl}&fields=${fields}`);
            
            tempAppUsers[app.id] = res.data;
        }
        setAppUsers(tempAppUsers);
        setIsLoading(false);
    }

    const renderAppUsers = (appId) => {
        let content;
        if (isLoading) {
            content = <Spinner size={SpinnerSize.large} />
        }
        else {
            const currentAppUsers = appUsers[appId];
            if (currentAppUsers) {
                content = Object.keys(currentAppUsers).map((x, index) => 
                    <div key={index} style={{margin: '5px 0px'}}>
                        <div style={{fontWeight: 'bold'}}>{userFieldsLabels[x]}:</div>
                        <div>{currentAppUsers[x].map((user, index) => <div key={index}>{user}</div>)}</div>
                    </div>);
            }
        }

        return <InfoTooltip content={content} />
    }

    const renderApps = (apps) => {
        return apps.map(x =>
            <div key={x.id} style={{display: "block", padding: "8px", backgroundColor: "rgb(243, 242, 241)"}}>
                <Link
                    target="_blank"
                    href={x.iCarUrl} 
                >
                    {x.name}
                </Link>
                {renderAppUsers(x.id)}
            </div>
        )
    }

    return(
        <div style={{paddingTop: 10}}>{renderApps(apps)}</div>
    )

}

export default CustomApplicationsList;


// WEBPACK FOOTER //
// ./src/components/EditSite/SiteEditElements/CustomApplicationsList.js